<template>
    <div @click="canRead && markAsRead()" class="notification mb--sm" :class="{'notification--highlighted': ! notification.read_at && highlight}">
        <div class="container notification__inner">
            <span class="btn btn--icon btn--white">
                <img src="/img/icons/user.svg" alt="">
            </span>
            <div>
                <slot/>
            </div>
        </div>
    </div>
</template>

<script>
import NotificationBase from "../../mixins/NotificationBase";

export default {
    mixins: [NotificationBase]
}
</script>
